/**
 * 系列页「隐藏筛选 / 显示筛选」开关（2026-08-29）。
 *
 * Dawn 的左侧栏筛选（filter_type: vertical）没有收起功能，这里补上。
 *
 * ⚠️ 收起状态记在 localStorage：翻页、换系列、筛选之后都保持。
 *    不记的话她每翻一页都要再点一次 —— 那比不给开关还烦。
 * ⚠️ 用事件委托 + MutationObserver：Dawn 的筛选是 Ajax 换整块 DOM 的
 *    （facets.js 会把 #ProductGridContainer 和侧栏整个替换掉），
 *    直接给按钮绑监听器，筛选一次就失效了。
 * ⚠️ 状态挂在容器的 data 属性上，显示/隐藏和文案全部交给 CSS ——
 *    JS 只负责切这一个属性，不去改 style，也不去改按钮文字。
 */
(function () {
  var KEY = 'torena-facets-hidden';

  function hidden() {
    try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function apply() {
    var on = hidden();
    // ⚠️ 状态挂在 <html> 上。按钮在 .facets-vertical 外面（必须在外面，
    //    否则收起后它自己也没了），两者分属不同子树，只有 <html> 是共同祖先。
    if (on) document.documentElement.setAttribute('data-facets-hidden', '');
    else document.documentElement.removeAttribute('data-facets-hidden');
    document.querySelectorAll('[data-torena-facet-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', on ? 'false' : 'true');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-torena-facet-toggle]');
    if (!btn) return;
    e.preventDefault();
    try { localStorage.setItem(KEY, hidden() ? '0' : '1'); } catch (err) {}
    apply();
  });

  // Dawn 筛选是 Ajax 重渲染的，换完 DOM 要把状态贴回去
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
